module.exports = __webpack_public_path__ + "0548baf6881180deff026f0f26e4a7bb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tablet.png
// module id = 244
// module chunks = 0